module.exports = __webpack_public_path__ + "static/media/D8PaloEUYAEBci6.000399b6.jpg";